import { batch } from 'react-redux';
import { noop } from 'lodash';
import { resetSelectedRows } from '../modules/campaigns-reports/actions';

const selectCampaignAndReport =
    (selectedCampaign, reportId, navigate = noop) =>
    dispatch => {
        batch(() => {
            navigate(selectedCampaign, reportId);
            dispatch(resetSelectedRows());
        });
    };

export default selectCampaignAndReport;
